"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class C64Layout {
    static concat(arrayBuffers) {
        if (arrayBuffers.length === 1) {
            return arrayBuffers[0];
        }
        return arrayBuffers.reduce((total, current) => {
            const result = new Uint8Array(total.length + current.length);
            result.set(total, 0);
            result.set(current, total.length);
            return result;
        });
    }
    static pad(buffer, numberOfBytes) {
        return this.concat([buffer, new Uint8Array(numberOfBytes)]);
    }
    static convertBitmap(pixelImage) {
        const bitmapSize = (pixelImage.mode.width * pixelImage.mode.height) / pixelImage.mode.pixelsPerByte();
        const bitmap = new Uint8Array(bitmapSize);
        let bitmapIndex = 0;
        pixelImage.mode.forEachCell(0, (x, y) => {
            pixelImage.mode.forEachCellRow(y, rowY => {
                pixelImage.mode.forEachByte(x, byteX => {
                    let packedByte = 0;
                    if (byteX >= pixelImage.mode.fliBugSize) {
                        pixelImage.mode.forEachPixel(byteX, (pixelX, shiftTimes) => {
                            packedByte |= pixelImage.mapPixelIndex(pixelX, rowY) << shiftTimes;
                        });
                    }
                    bitmap[bitmapIndex] = packedByte;
                    bitmapIndex += 1;
                });
            });
        });
        return bitmap;
    }
    static convertScreenram(pixelImage, lowerColorIndex, upperColorIndex, yOffset = 0) {
        return pixelImage.extractAttributeData(yOffset, (x, y) => {
            return (((pixelImage.colorMaps[upperColorIndex].get(x, y) << 4) & 0xf0) |
                (pixelImage.colorMaps[lowerColorIndex].get(x, y) & 0x0f));
        });
    }
    static convertColorram(pixelImage, colorMapIndex) {
        return pixelImage.extractAttributeData(0, (x, y) => {
            return pixelImage.colorMaps[colorMapIndex].get(x, y) & 0x0f;
        });
    }
}
exports.default = C64Layout;
//# sourceMappingURL=C64Layout.js.map